import { RootState } from "../store";

export const selectAppState = (state: RootState) => state.app;
export const selectAppLanguage = (state: RootState) => state.app.appContext.language;
export const selectAppNumberFormat = (state: RootState) => state.app.appContext.numberFormat;
export const selectAppContext = (state: RootState) => state.app.appContext;
